var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-bottom","mode":"out-in"}},[(_vm.isSocketOffline)?_c('div',{staticClass:"socket-notification notification-handler offline__notification-handler"},[_c('CloudOffIcon',{staticClass:"icon"}),_vm._v("\n        "+_vm._s(_vm.$t('common.socketOffline'))+"\n    ")],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }